<template>
    <v-btn id="show-comments-button"
        :class="{ selected: isGuest }"
        @click="onClick"
        content="Discussion"
        v-tippy="{placement: 'left'}"
    >
        <i class="material-symbols-outlined">chat_bubble</i>
        <CommentCounter :count="commentCount" />
    </v-btn>
</template>

<script>
import CommentCounter from "@/components/app/comments/CommentCounter.vue";
import { mapGetters } from "vuex";

export default {
    components: {CommentCounter},
    computed: {
        ...mapGetters('User', ['isGuest']),
        commentCount() {
            if (!this.image) return null;

            let notifications = [];
            if (this.isGuest) notifications = this.newCommentNotificationsOfFile(this.currentFile.parent_file_id);
            else notifications = this.newCommentNotificationsOfFile(this.image);

            return notifications.length;
        }
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setRightColumn', 'comments')
        },
    },
};
</script>

<style lang="scss" scoped>
#show-comments-button {
    overflow: visible;
}
</style>
